export enum Tier {
  Tier1 = 'Tier 1',
  Tier1_5 = 'Tier 1.5',
  Tier2 = 'Tier 2',
  Tier2_5 = 'Tier 2.5',
  Tier3 = 'Tier 3',
  Tier3_5 = 'Tier 3.5',
  Tier4 = 'Tier 4',
  Tier4_5 = 'Tier 4.5',
  Tier5 = 'Tier 5',
  Tier5_5 = 'Tier 5.5',
  Tier6 = 'Tier 6',
  Tier7 = 'Tier 7',
}


